<template>
  <div style="padding: 50px;">
    <b-link
      v-if="isInRole('SmartGrabberUser')"
      class="btn btn-lg btn-primary module__link"
      style="width: 180px; margin: 1rem 0.5rem;"
      data-module="datagrabber"
      to="/smartgrabber"
      >SmartGrabber
    </b-link>
    <b-link
        v-if="isInRole('GbqUser')"
        class="btn btn-lg btn-primary module__link"
        style="width: 180px; margin: 1rem 0.5rem;"
        data-module="gbq-grabber"
        to="/big-query-grabber"
    >Big Query
    </b-link>
    
<!--    <b-link-->
<!--      v-if="isInRole('SmartGrabberUser')"-->
<!--      class="btn btn-lg btn-primary module__link"-->
<!--      style="width: 180px; margin: 1rem 0.5rem;"-->
<!--      data-module="dataset"-->
<!--      to="/manage-dataset"-->
<!--      >Datasets (beta)-->
<!--    </b-link>-->
<!--    <b-link-->
<!--      v-if="isInRole('SmartGrabberUser')"-->
<!--      class="btn btn-lg btn-primary module__link"-->
<!--      style="width: 220px; margin: 1rem 0.5rem;"-->
<!--      data-module="dataset"-->
<!--      to="/charts-report"-->
<!--      >Chart Report (beta)-->
<!--    </b-link>-->

    <b-link
        v-if="isInRole('TableauUser')"
        class="btn btn-lg btn-primary module__link"
        style="width: 180px; margin: 1rem 0.5rem;"
        data-module="reports"
        :to="{ name: 'Reports' }"
    >Tableau Views
    </b-link>
  </div>
</template>

<script>
import application from '@/mixins/application';

export default {
  name: 'Home',
  mixins: [application],
};
</script>